import axios from 'axios';

export const fetchSettings = async (serverBaseUrl) => {
  const response = await axios.get(`${serverBaseUrl}/api/v1/settings`, { withCredentials: true });
  return response.data.settings;
};

export const updateDeviceSettings = async (updatedSetting, serverBaseUrl) => {
  return axios.patch(`${serverBaseUrl}/api/v1/settings`, updatedSetting, {
    withCredentials: true,
  });
};

export const fetchCalibrationFromDevice = async (serverBaseUrl) => {
  const csrfToken = localStorage.getItem('csrfToken');

  const headers = {
    'Content-Type': 'application/json; charset=utf-8',
    'X-CSRF-Token': csrfToken,
  };

  const response = await axios.get(`${serverBaseUrl}/api/v1/diagnostics/device/calibration`, {
    withCredentials: true,
    headers,
  });

  return response.data;
};

export const fetchDeviceDiagnostics = async (acquireBaseUrl) => {
  if (!acquireBaseUrl) {
    throw new Error('Missing acquire base URL');
  }

  const csrfToken = localStorage.getItem('csrfToken');

  const headers = {
    'Content-Type': 'application/json; charset=utf-8',
    'X-CSRF-Token': csrfToken,
  };

  const response = await axios.get(`${acquireBaseUrl}/diagnostics/device`, {
    withCredentials: true,
    headers,
  });

  return response.data;
};
